import EventSubscriptionsTable from "./EventSubscriptionsTable";
export default EventSubscriptionsTable;
